// "Save as my default view" on the Tasks page (firm, 2026-10-30: "is there a
// way that I can customize how it opens whenever I open it?").
//
// Per user, per browser, in localStorage. It holds the tab, the Filter panel's
// values (fiscal year and year-end month included), the Status checklist (so
// whether Completed shows), the Person filter, the client-status filter and
// the Planning chip. Search is deliberately NOT saved, for the reason
// workflow/filterPrefs.js gives: a box that silently refills on open hides
// most of the grid while looking empty.
//
// try/catch on both sides like filterPrefs.js -- private browsing and
// locked-down webviews throw on localStorage -- and every field is validated
// on read, so a view saved by an older build can only ever fall back to the
// built-in default, never break the page.

const PREFIX = "tasksDefaultView:";

export const defaultViewKey = (userId) => `${PREFIX}${userId ?? "anon"}`;

const isStringArray = (v) => Array.isArray(v) && v.every((x) => typeof x === "string");

// null when nothing (valid) is saved -- the page then opens exactly as before.
export function loadDefaultView(userId, { tabKeys = [], filterKeys = [] } = {}) {
  let stored = null;
  try {
    const raw = localStorage.getItem(defaultViewKey(userId));
    if (raw) stored = JSON.parse(raw);
  } catch (e) {
    stored = null;
  }
  if (!stored || typeof stored !== "object") return null;

  const view = {};
  if (typeof stored.tab === "string" && tabKeys.includes(stored.tab)) view.tab = stored.tab;
  if (stored.filters && typeof stored.filters === "object") {
    // Only filters this build knows, and only string values (every Filter
    // panel control is a <select> whose "off" value is "").
    const filters = {};
    for (const k of filterKeys) {
      if (typeof stored.filters[k] === "string") filters[k] = stored.filters[k];
    }
    view.filters = filters;
  }
  if (isStringArray(stored.hiddenStatuses)) view.hiddenStatuses = stored.hiddenStatuses;
  if (isStringArray(stored.personFilter)) view.personFilter = stored.personFilter;
  if (isStringArray(stored.clientStatuses) && stored.clientStatuses.length) {
    view.clientStatuses = stored.clientStatuses;
  }
  if (typeof stored.includePlanning === "boolean") view.includePlanning = stored.includePlanning;
  return Object.keys(view).length ? view : null;
}

export function saveDefaultView(userId, view) {
  try {
    localStorage.setItem(defaultViewKey(userId), JSON.stringify({
      tab: view.tab,
      filters: view.filters,
      hiddenStatuses: [...view.hiddenStatuses],
      personFilter: [...view.personFilter],
      clientStatuses: [...view.clientStatuses],
      includePlanning: Boolean(view.includePlanning),
    }));
    return true;
  } catch (e) {
    return false;
  }
}

export function clearDefaultView(userId) {
  try {
    localStorage.removeItem(defaultViewKey(userId));
  } catch (e) {
    // Nothing to clear, or storage is off. Either way there is no default.
  }
}
